import Icon from "@material-ui/icons/SpeakerNotesOff";
import NotTakingsList from "./NotTakingsList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "notTakings",
  list: NotTakingsList,
  icon: Icon,
};
